import BaseListagem from "components/BaseListagem";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Column, ColumnFilterElementTemplateOptions } from "primereact/column";
import { DataTableFilterMeta } from "primereact/datatable";
import { InputNumber } from "primereact/inputnumber";
import { useState } from "react";
import UnidadeOrganizacionalService from "service/indicadores/UnidadeOrganizacionalService";
import { filterApplyTemplate, NumberMatchModeOptions, TextMatchModeOptions } from "utils/filterUtils";

const unidadeOrganizacionalService = new UnidadeOrganizacionalService();

export default function UnidadeOrganizacionalListagem() {

    const [titulo, setTitulo] = useState<string>('Unidade Organizacional');

    const defaultFilters: DataTableFilterMeta = {
        codigoInterno: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        nome: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        }
    }

    const numberFilterTemplate = (options: ColumnFilterElementTemplateOptions) => {
        return <InputNumber
            value={options.value} onValueChange={(e) => options.filterCallback(e.value)}
            useGrouping={false} minFractionDigits={0} maxFractionDigits={0}
            placeholder="Escreva o filtro"
        />;
    }

    return (
        <BaseListagem ordenacao="nome,ASC" service={unidadeOrganizacionalService} urlService="/unidadeOrganizacional" tituloPagina={titulo} defaultFilters={defaultFilters} showClearFilterButton nome="unidadeOrganizacional">
            <Column field="codigoInterno" header="Código" style={{ width: 50 }} filter showFilterOperator={false} showAddButton={false} filterElement={numberFilterTemplate}
                filterMatchModeOptions={NumberMatchModeOptions} filterApply={filterApplyTemplate} />
            <Column field="nome" header="Nome" filter showFilterOperator={false} showAddButton={false}
                filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} filterPlaceholder="Escreva o filtro" />
        </BaseListagem>
    )
}